<template>
  <div>
    <general-table
      ref="generalTable"
      :api-url="apiUrl"
      :add-component-name="addComponentName"
      :edit-component="editComponent"
      :delete-content="true"
      :block-content="false"
      :edit-content="true"
      :view-content="false"
      :add-type="addType"
      :columns="columns"
      :type="type"
    >
      <template #cell(users_list)="data">
        <div
          class="d-flex flex-wrap align-items-center px-1"
          style="min-width: 150px"
        >
          <template v-if="Array.isArray(data.item.users) && data.item.users.length > 0">
            <div
              v-for="(user, index) in data.item.users.slice(0, 4)"
              :key="user.id || index"
              :style="{ marginLeft: index !== 0 ? '-5px' : '0' }"
            >
              <span
                v-b-popover.hover.top.html="getSpan(user.name, user.email)"
              >
                <b-avatar
                  class="hover-avatar"
                  size="28"
                  :style="{
                    backgroundColor: colors[index % colors.length],
                    color: 'white',
                  }"
                  :text="getInitials(user.name)"
                />
              </span>
            </div>

            <div
              v-if="data.item.users.length > 4"
              :style="{ marginLeft: '-5px' }"
            >
              <span
                v-b-popover.hover.right.html="getRemainingAuditorsPopover(data.item.users.slice(4))"
              >
                <b-avatar
                  size="28"
                  variant="light-secondary"
                  class="font-weight-bold"
                >
                  +{{ data.item.users.length - 4 }}
                </b-avatar>
              </span>
            </div>
          </template>

          <template v-else>
            <span class="text-muted small">No users</span>
          </template>
        </div>
      </template>
      <template #cell(add_edit_users)="data">
        <div class="d-flex justify-content-center align-content-center">
          <img
            src="@/assets/images/icons/user.png"
            class="cursor-pointer"
            width="40"
            height="40"
            @click="openUsersModal(data.item.id)"
          >
        </div>
      </template>
    </general-table>

    <b-modal
      v-model="showUsersModal"
      title="Manage Users"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      ok-title="Submit"
      :ok-disabled="isSubmitting"
      @ok="submitUsers"
      @hidden="clearReimbursementForm"
    >
      <div>
        <!-- <p><strong>ID:</strong> {{ selectedRow }}</p> -->
        <v-select
          id="user_id"
          v-model="reimbursementForm.user_id"
          :options="optionsAllUser"
          :reduce="option => option.value.id"
          trim
          placeholder="user"
          value="id"
          multiple
        />

      </div>

      <div
        class="mt-2"
        style="max-height: 70vh; overflow-y: auto;"
      >
        <b-list-group>
          <b-list-group-item
            v-for="(user , index) in usersList"
            :key="index"
            class="d-flex justify-content-between"
          >
            <span> {{ user.name }} --
              {{ user.email }}  </span>
            <span>
              <feather-icon
                icon="TrashIcon"
                class="cursor-pointer"
                color="red"
                @click="removeUser(user.id)"
              />
            </span>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-modal>

  </div>

</template>

<script>
import axios from 'axios'
import VSelect from 'vue-select'
import GeneralTable from '@/components/general-table/GeneralTable.vue'
import decryptData from '@/store/auth/decryptData'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    GeneralTable,
    'v-select': VSelect,
    FeatherIcon,
  },
  data() {
    return {
      APIURL: 'sfda-sources',
      addType: 'Add SFDA Sources',
      addComponentName: 'add-sfda-sources',
      editComponent: 'edit-sfda-sources',
      viewContent: true,
      type: 'page',
      selectedRow: null,
      showUsersModal: false,
      isSubmitting: false,
      reimbursementForm: [],
      filter: {},
      allUsers: [],
      usersList: [],
      types: '',
      columns: [
        { key: 'id', sortable: true },
        { key: 'name', label: 'Name' },
        { key: 'users_list', label: 'Users List' },
        { key: 'add_edit_users', label: 'Change Users' },
        { key: 'actions' },
      ],
      colors: [
        '#FF5733', // red-orange
        '#33B5FF', // blue
        '#28A745', // green
        '#FFC107', // amber
        '#6F42C1', // purple
        '#E83E8C', // pink
        '#20C997', // teal
        '#FD7E14', // orange
      ],
    }
  },

  computed: {

    apiUrl() {
      let base = 'sfda-sources?'

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      return base.slice(0, -1)
    },
    optionsAllUser() {
      return this.$store.getters['generalData/assignList/assignList']
    },
  },
  watch: {
    selectedRow(newVal) {
      if (newVal) {
        this.fetchUsersForSource(newVal)
      }
    },
  },

  async mounted() {
    if (!this.$store.getters['generalData/assignList/assignListLoaded']) {
      await this.$store.dispatch('generalData/assignList/fetchAssignList')
    }
  },
  methods: {
    getRemainingAuditorsPopover(auditors) {
    // Build HTML popover with all remaining auditors
      return auditors
        .map(
          auditor => `
        <div style="text-align:start; margin-bottom:4px;">
          <div style="color:black; font-weight:500;">${auditor.name}</div>
          <div style="color:gray;">${auditor.email}</div>
        </div>
      `,
        )
        .join('')
    },
    getInitials(fullName) {
      if (!fullName) return ''
      const str = String(fullName).trim()
      if (!str) return ''
      const parts = str.split(/\s+/)
      if (parts.length === 1) {
        return parts[0][0]?.toUpperCase() || ''
      }
      return (parts[0][0] + parts[1][0]).toUpperCase()
    },
    getSpan(name, email) {
      return `<div style="text-align: start; color: black">${name}</div>
    <div style="text-align: start; color: gray">${email}</div>`
    },
    openUsersModal(item) {
      this.selectedRow = item
      this.showUsersModal = true
    },
    clearReimbursementForm() {
      this.showUsersModal = false
      this.reimbursementForm = []
      this.selectedRow = null
      this.$refs.generalTable.getAllData()
    },
    async fetchUsersForSource(id) {
      try {
        const response = await axios.get(`sfda-sources/${id}/users`)
        this.usersList = decryptData(response.data.payload).data
      } catch (error) {
        this.$bvToast.toast('users list not found.', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true,
        })
      }
    },
    async submitUsers(bvModalEvt) {
      // Prevent modal from closing automatically
      bvModalEvt.preventDefault()

      if (!this.reimbursementForm.user_id || this.reimbursementForm.user_id.length === 0) {
        this.$bvToast.toast('Please select at least one user.', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true,
        })
        return
      }

      this.isSubmitting = true

      try {
        await axios.post(`sfda-sources/${this.selectedRow}/assign`, {
          user_ids: this.reimbursementForm.user_id,
        })

        this.$bvToast.toast('Users updated successfully.', {
          title: 'Success',
          variant: 'success',
          solid: true,
        })

        this.clearReimbursementForm()
      } catch (err) {
        this.$bvToast.toast('Failed to update users.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.isSubmitting = false
      }
    },
    removeUser(id) {
      axios.delete(`sfda-sources/${this.selectedRow}/unassign`, {
        data: {
          user_ids: [id],
        },
      })
        .then(() => {
          this.$bvToast.toast('User removed successfully.', {
            title: 'Success',
            variant: 'success',
            solid: true,
          })

          // Remove from UI list also
          this.usersList = this.usersList.filter(u => u.id !== id)
        })
        .catch(() => {
          this.$bvToast.toast('Failed to remove user.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },

  },

}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .avatar-wrapper {
  transition: all 0.2s ease;
}

.hover-avatar {
  transition: transform 0.2s ease, z-index 0.2s ease;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.hover-avatar:hover {
  transform: translateY(-5px);
  z-index: 10;
}
  </style>
